import '../sass/contact-form.scss';

import animationData from '../../../../assets/lottie/logo.json';

(() => {
    const pristineScript = document.querySelector('#boomspace-theme-pristine-js');
    const $blocks = document.querySelectorAll('.contact-form');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $formWrapper = $block.querySelector('.contact-form__form-wrapper');
        const $formLoader = $block.querySelector('.contact-form__form-loader');
        const $form = $block.querySelector('.contact-form__form');
        const $turnstile = $block.querySelector('.contact-form__turnstile');
        const $turnstileToken = $block.querySelector('.contact-form__turnstile-token');

        const checkIfTurnstileReady = resolve => {
            const interval = setInterval(() => {
                if (!$turnstileToken.value) return;

                resolve(interval);
                clearInterval(interval);
            }, 100);
        };

        const initForm = () => {
            if (!$form) return;

            const loaderAnimation = $formLoader && lottie ? lottie.loadAnimation({
                container: $formLoader,
                renderer: 'canvas',
                loop: true,
                autoplay: false,
                animationData: animationData,
                rendererSettings: {
                    preserveAspectRatio: 'none'
                }
            }) : null;

            const pristine = new Pristine($form);
            
            $form.addEventListener('submit', e => {
                e.preventDefault();

                $formWrapper.classList.add('contact-form__form-wrapper--loading');

                if (loaderAnimation) {
                    loaderAnimation.goToAndPlay(0);
                }

                if (!pristine.validate()) {
                    $formWrapper.classList.remove('contact-form__form-wrapper--loading');
                }

                if ($turnstile) {
                    const waitUntilReady = new Promise(checkIfTurnstileReady);

                    waitUntilReady.then(() => {
                        if (!pristine.validate()) return;
                        
                        $form.submit();
                    });
                } else {
                    $form.submit();
                }
            });
        };

        window.onloadTurnstileCallback = () => {
            if (!$turnstile) return;

            turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        };

        if (typeof Pristine !== 'undefined') { 
            initForm();
        } else {
            pristineScript.addEventListener('load', () => {
                initForm();
            });
        }
    });
})();
